import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxCardObject from "src/components/card/SfxCardObject.vue"
import router from "src/router"
import { useConfigurationStore } from "src/stores/configurationStore"
import { useUnsubmittedWorkStore } from "src/stores/unsubmittedWork"
import { NamedPath } from "src/util/enums/namedPaths"
import { getUnsubmittedAttachments } from "src/util/functions/unsubmittedData"
import { PayloadEntity } from "src/util/types/dataModels/genericObject"
import {
  UnsubmittedWork,
  UnsubmittedWorkEntity,
  UnsubmittedWorkWithEntity,
} from "src/util/types/dataModels/unsubmittedWork"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogListUnsubmittedWork',
  props: {
  unsubmittedWorkList: {
    type: Array as PropType<PayloadEntity<UnsubmittedWorkWithEntity>[]>,
    required: true,
  },

  entity: {
    type: String as PropType<UnsubmittedWorkEntity>,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()
const configurationStore = useConfigurationStore()
const { dialogRef, onDialogHide } = useDialogPluginComponent()

const entity = computed(() => {
  let result
  if (props.entity === "issue") {
    result = t("issue.label_issue")
  } else if (props.entity === "item") {
    result = t("item.item")
  } else {
    result = t("area.area")
  }

  return result
})

const title = t("sfxDialogListUnsubmittedWork.title")
const bodyText = t("sfxDialogListUnsubmittedWork.text_body", { entity: entity.value })
const btnDontShow = t("sfxButtons.btn_dont_show")
const btnGotIt = t("sfxButtons.btn_got_it")
const untitledWorkLabel = t("toDo.untitled_work")

//endregion

//region Functions

async function goToUnsubmittedWork(unsubmittedWork: UnsubmittedWork) {
  const unsubmittedWorkStore = useUnsubmittedWorkStore()
  unsubmittedWorkStore.unsubmittedWork = unsubmittedWork

  if (unsubmittedWork.attachments.length > 0) {
    const unsubmittedWorkAttachments = await getUnsubmittedAttachments(unsubmittedWork.attachments)
    if (unsubmittedWorkAttachments) {
      unsubmittedWorkStore.unsubmittedImages = unsubmittedWorkAttachments
    }
  }

  if (unsubmittedWork.work_type === "adhocCorrective") {
    await router.push({
      name: NamedPath.ADHOC_CORRECTIVE_WORK,
      params: { issueId: unsubmittedWork.entity_id },
    })
  } else if (unsubmittedWork.work_type === "adhocRegular") {
    await router.push({
      name: NamedPath.ADHOC_REGULAR_WORK,
      params: { itemId: unsubmittedWork.entity_id },
    })
  }
}

function doNotShowAgain() {
  configurationStore.hideUnsubmittedWorkListDialog[
    props.unsubmittedWorkList[0].unsubmittedWork.entity_id
  ] = true
  onDialogHide()
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin sfx-dialog-list" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-pb-lg" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-body1 q-pb-sm" }, {
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _unref(bodyText) }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.unsubmittedWorkList, (unsubmittedWorkCardData, index) => {
                return (_openBlock(), _createBlock(SfxCardObject, {
                  key: index,
                  class: "q-my-md",
                  "object-type": unsubmittedWorkCardData.unsubmittedWork.work_type,
                  title: unsubmittedWorkCardData.unsubmittedWork?.title,
                  "title-placeholder": _unref(untitledWorkLabel),
                  "date-time": unsubmittedWorkCardData.unsubmittedWork.declared_dt,
                  "entity-type": unsubmittedWorkCardData.unsubmittedWork.entity_type,
                  "entity-data": unsubmittedWorkCardData.entityData,
                  onClick: ($event: any) => (goToUnsubmittedWork(unsubmittedWorkCardData.unsubmittedWork))
                }, null, 8, ["object-type", "title", "title-placeholder", "date-time", "entity-type", "entity-data", "onClick"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-pa-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                label: _unref(btnDontShow),
                class: "col",
                onClick: doNotShowAgain
              }, null, 8, ["label"]),
              _createVNode(SfxBtn, {
                label: _unref(btnGotIt),
                class: "col",
                onClick: _unref(onDialogHide)
              }, null, 8, ["label", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})